import { Link } from "react-router-dom";
import { timeline } from "@/mocks/timeline";
import InfoBadge from "@/components/base/InfoBadge";
import SectionHeading from "@/components/base/SectionHeading";

export default function TimelineSection() {
  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-content px-4 py-12 md:px-6 md:py-14">
        <SectionHeading
          eyebrow="后续进展"
          title="事件时间线：关键节点一目了然"
          desc="按发布时间排列，每条节点都标注了可信等级。完整版本包含更多比对细节。"
          action={
            <Link
              to="/article/timeline-full"
              className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              完整时间线
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          }
        />

        <ol className="grid grid-cols-1 gap-x-10 gap-y-6 md:grid-cols-2">
          {timeline.map((ev) => (
            <li key={ev.date} className="relative flex gap-4 pb-6 last:pb-0 md:pb-0">
              <div className="flex flex-col items-center">
                <span className="flex h-3 w-3 shrink-0 items-center justify-center rounded-full border-2 border-primary-500 bg-background-50">
                  <span className="h-1 w-1 rounded-full bg-primary-500"></span>
                </span>
                <span className="mt-1 w-px flex-1 bg-background-300" aria-hidden="true"></span>
              </div>
              <div className="min-w-0 flex-1 pb-2">
                <div className="flex flex-wrap items-center gap-2">
                  <time className="font-heading text-sm font-bold text-primary-600">{ev.date}</time>
                  <InfoBadge level={ev.level} />
                </div>
                <h3 className="mt-1.5 text-sm font-semibold text-foreground-900 md:text-base">{ev.title}</h3>
                <p className="mt-1 text-xs leading-relaxed text-foreground-600 md:text-sm">{ev.desc}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}